import React from 'react'
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import { Query } from 'react-apollo'

// graphql
import miniMe from 'graphql/queries/miniMe'
import assenze from 'graphql/queries/assenze'
import azioni from 'graphql/queries/azioni'
import utenti from 'graphql/queries/utenti'

// core components
import RegularCard from 'components/Cards/RegularCard.jsx'
import CalendarModalForm from 'components/CalendarModalForm/CalendarModalForm'

// css
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './CalendarioGiorno.css'

BigCalendar.momentLocalizer(moment)


class CalendarioGiorno extends React.Component {
  constructor(props) {
    super(props)

    // Voglio l'ora su 24 ore
		let timeRangeFormat = ({ start, end }, culture, local) =>
    local.format(start, 'HH:mm', culture) +
    ' - ' + local.format(end, 'HH:mm', culture)

    let dayHeaderFormat = (Date, culture, local) =>
    local.format(Date, 'ddd DD MMMM', culture)

    this.state = {
      eventsType: 'calendar',
      showModal: false,
      initialValues: {},
      isNewEvent: true,
      isMyCalendar: false,
      error: '',
      dataCorrente: moment().format('YYYY-MM-DD'),
      messages: {
        date: 'Data',
        time: 'Ora',
        event: 'Appuntamento',
        allDay: 'Tutto il giorno',
        previous: '<',
        next: '>',
        today: 'Oggi',
        day: 'Giorno',
      },
      formats: {
        selectRangeFormat: timeRangeFormat,
        dayHeaderFormat: dayHeaderFormat
      }
    }
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      initialValues: {},
      error: ''
    })
  }

  setErrorMessage = errorMessage => {
    this.setState({
      error: errorMessage
    })
  }

  addNewEventAlert(slotInfo, ruolo, myId) {
    const isMyCalendar = myId === slotInfo.resourceId

    const initialValues = {
      tipoEvento: (ruolo === 'AGENTE' && !isMyCalendar) ? 'appuntamento' : '',
      start: moment(slotInfo.start).toDate(),
      end: moment(slotInfo.end).toDate(),
      agenteId: slotInfo.resourceId,
      clienteId: '',
      luogo: '',
      appuntamentoOrigine: '',
      stato: 'FISSATO_AGENTE',
      descrizione: '',
      title: ''
    }
    
    this.setState({
      showModal: true,
      initialValues: initialValues,
      isNewEvent: true,
      isMyCalendar: isMyCalendar
    })
  }

  selectedEvent(evento, ruolo, myId) {
    const isMyCalendar = myId === evento.agenteId

    if (ruolo === 'ADMIN' || ruolo === 'SEGRETARIA' || (ruolo === 'AGENTE' && !!isMyCalendar)) {
      const initialValues = {
        id: evento.id,
        tipoEvento: evento.tipoEvento,
        start: evento.start,
        end: evento.end,
        agenteId: evento.agenteId,
        clienteId: evento.clienteId,
        luogo: evento.luogo,
        stato: evento.stato,
        appuntamentoOrigine:evento.appartamentoOrigine,
        descrizione: evento.descrizione,
        title: evento.title
      }
      
      this.setState({
        showModal: true,
        initialValues: initialValues,
        isNewEvent: false,
        isMyCalendar: isMyCalendar
      })
    }
  }

  eventColors(evento) {
    let backgroundColor = "#ccc"

    switch (evento.tipoEvento.toLowerCase()) {
      case 'appuntamento':
        switch (evento.stato.toUpperCase()) {
          case 'FISSATO_AGENTE':
            backgroundColor = '#ff9800'
            break
          case 'CONFERMATO_SEGRETARIA':
            backgroundColor = '#00bcd4'
            break
          case 'CONFERMATO_CLIENTE':
            backgroundColor = '#0476be'
            break
          case 'ANNULLATO_CLIENTE':
            backgroundColor = '#e83f3f'
            break
          case 'SALTATO':
            backgroundColor = '#e83f3f'
            break
          case 'FATTO':
            backgroundColor = '#85ce1a'
            break
          default:
            break
        }
        break
      case 'assenza-occupato':
        backgroundColor = '#999'
        break
      case 'assenza-fuori-sede':
        backgroundColor = '#a43fb5'
        break
      default:
        break
    }

    return {
      style: { backgroundColor }
    }
  }

  tipoEvento(tipoAzione, assenzaIsOccupato) {
    if (!!tipoAzione) {
      return tipoAzione.tipo
    }
    if (!!assenzaIsOccupato) {
      return 'assenza-occupato'
    }
    return 'assenza-fuori-sede'
  }

  titoloEvento(tipoAzione, nomeCliente, descrizione, assenzaIsOccupato) {
    if (!!tipoAzione) {
      return nomeCliente
    }
    if (!!descrizione) {
      return descrizione
    } else {
      if (!!assenzaIsOccupato) {
        return 'Assente (occupato)'
      }
      return 'Assente (fuori sede)'
    }
  }

  handleNavigate = date => {
    this.setState({
      dataCorrente: moment(date).format('YYYY-MM-DD HH:mm')
    })
  }


  render() {
    const { eventsType, showModal, initialValues, isNewEvent, messages, formats } = this.state

    return (
      <div className="calendario-giorno">
        <Query query={miniMe}>
          {({ loading, error, data: { me } }) => {
            if (loading) return <p>Loading...</p>
            if (error) return <p>Error :(</p>

            const startOfDay = moment(this.state.dataCorrente).startOf('day').subtract(1, 'days').format('YYYY-MM-DD')
            const endOfDay = moment(this.state.dataCorrente).endOf('day').add(1, 'days').format('YYYY-MM-DD')

            return (
              <div>
                <Query 
                  query={assenze}
                  variables={{
                    limit: 200,
                    where: {
                      OR: [
                        {
                          daDataOra_gte: startOfDay,
                          daDataOra_lte: endOfDay
                        },
                        {
                          aDataOra_gte: startOfDay,
                          aDataOra_lte: endOfDay
                        },
                        {
                          daDataOra_lte: startOfDay,
                          aDataOra_gte: endOfDay
                        }
                      ]
                    }
                  }}
                  fetchPolicy="cache-and-network"
                >
                  {({ loading, error, data: { assenze } }) => {
                    if (loading) return <p>Loading...</p>
                    if (error) return <p>Error :(</p>

                    const assenzeGiorno = assenze.nodes

                    return (
                      <Query 
                        query={azioni}
                        variables={{
                          limit: 200,
                          where: {
                            AND: [
                              {
                                tipoAzioneId: 1,
                              },
                              {
                                OR: [
                                  {
                                    appuntamentoDaDataOra_gte: startOfDay,
                                    appuntamentoDaDataOra_lte: endOfDay
                                  },
                                  {
                                    appuntamentoADataOra_gte: startOfDay,
                                    appuntamentoADataOra_lte: endOfDay
                                  },
                                  {
                                    appuntamentoDaDataOra_lte: startOfDay,
                                    appuntamentoADataOra_gte: endOfDay
                                  }
                                ]
                              }
                            ]
                          }
                        }}
                        fetchPolicy="cache-and-network"
                      >
                        {({ loading, error, data: { azioni } }) => {
                          if (loading) return <p>Loading...</p>
                          if (error) return <p>Error :(</p>
                          
                          const appuntamentiGiorno = azioni.nodes
                          
                          const eventi = [...assenzeGiorno, ...appuntamentiGiorno]
  
                          const eventiCalendario = eventi.map(e => {
                            // console.log(e)
  
                            const appuntamentoDaDataOra = e.appuntamentoDaDataOra && moment(e.appuntamentoDaDataOra, 'YYYY-MM-DD HH:mm').toDate()
                            const appuntamentoADataOra = e.appuntamentoADataOra && moment(e.appuntamentoADataOra, 'YYYY-MM-DD HH:mm').toDate()
                            const assenzaDaDataOra = e.daDataOra && moment(e.daDataOra, 'YYYY-MM-DD HH:mm').toDate()
                            const assenzaADataOra = e.aDataOra && moment(e.aDataOra, 'YYYY-MM-DD HH:mm').toDate()

                            const isAppuntamentoAllDay = e.appuntamentoDaDataOra && (appuntamentoDaDataOra.toString().indexOf('00:00:00') > 0 && appuntamentoADataOra.toString().indexOf('00:00:00') > 0 ? true : false)
                            const isAssenzaAllDay = e.daDataOra && (assenzaDaDataOra.toString().indexOf('00:00:00') > 0 && assenzaADataOra.toString().indexOf('00:00:00') > 0 ? true : false)
                            
                            // APPUNTAMENTI E ASSENZE "ALL DAY" (da mezzanotte a mezzanotte)
                            // CONVERTITI IN EVENTI DALLE 9 ALLE 19 (solo su questo calendario)
                            let myAppuntamentoDaDataOra = appuntamentoDaDataOra
                            let myAppuntamentoADataOra = appuntamentoADataOra
                            let myAssenzaDaDataOra = assenzaDaDataOra
                            let myAssenzaADataOra = assenzaADataOra

                            if (isAppuntamentoAllDay) {
                              myAppuntamentoDaDataOra = moment(e.appuntamentoDaDataOra, 'YYYY-MM-DD HH:mm').add(9, 'hours').toDate()
                              myAppuntamentoADataOra = moment(e.appuntamentoADataOra, 'YYYY-MM-DD HH:mm').add(19, 'hours').toDate()
                            }
                            if (isAssenzaAllDay) {
                              myAssenzaDaDataOra = moment(e.daDataOra, 'YYYY-MM-DD HH:mm').add(9, 'hours').toDate()
                              myAssenzaADataOra = moment(e.daDataOra, 'YYYY-MM-DD HH:mm').add(19, 'hours').toDate()
                            }

                            return ({
                              id: e.id,
                              tipoEvento: this.tipoEvento(e.tipoAzione, e.flagOccupato),
                              title: this.titoloEvento(e.tipoAzione, e.cliente && e.cliente.nome, e.descrizione, e.flagOccupato),
                              allDay: false,
                              start: e.tipoAzione ? myAppuntamentoDaDataOra : myAssenzaDaDataOra,
                              end: e.tipoAzione ? myAppuntamentoADataOra : myAssenzaADataOra,
                              agenteId: e.tipoAzione ? e.appuntamentoAgente.id : e.utenteId,
                              clienteId: e.cliente ? e.cliente.id : null,
                              luogo: e.appuntamentoLuogo ? e.appuntamentoLuogo : null,
                              appuntamentoOrigine: e.appuntamentoOrigine ? e.appuntamentoOrigine : null, 
                              stato: e.appuntamentoStato ? e.appuntamentoStato : null,
                              descrizione: e.descrizione,
                              resourceId: e.tipoAzione ? e.appuntamentoAgente.id : e.utenteId
                            })
                          })
                          // console.log("eventiCalendario: ", eventiCalendario)

                          return (
                            <Query 
                              query={utenti}
                              variables={{
                                limit: 20,
                                where: {
                                  ruolo: 'AGENTE',
                                  riceveForm: true
                                }
                              }}
                              fetchPolicy="cache-and-network"
                            >
                              {({ loading, error, data: { utenti } }) => {
                                if (loading) return <p>Loading...</p>
                                if (error) return <p>Error :(</p>

                                const agenti = utenti.nodes
                                  
                                const resourceMap = agenti.map(agente => {
                                  return (
                                    { resourceId: agente.id, resourceTitle: agente.nome }
                                  )
                                })

                                return (
                                  <div>
                                    <RegularCard
                                      content={
                                        <BigCalendar
                                          date={moment(this.state.dataCorrente).toDate()}
                                          selectable
                                          popup
                                          events={eventiCalendario}
                                          defaultView="day"
                                          messages={messages}
                                          formats={formats}
                                          scrollToTime={new Date(2018, 1, 1)}
                                          defaultDate={new Date()}
                                          onSelectEvent={evento => this.selectedEvent(evento, me.ruolo, me.id)}
                                          onSelectSlot={slotInfo => this.addNewEventAlert(slotInfo, me.ruolo, me.id)}
                                          eventPropGetter={this.eventColors}
                                          views={['day']}
                                          onNavigate={this.handleNavigate}
                                          showMultiDayTimes={true}
                                          resources={resourceMap}
                                          resourceIdAccessor="resourceId"
                                          resourceTitleAccessor="resourceTitle"
                                        />
                                      }
                                    />

                                    <CalendarModalForm
                                      eventsType={eventsType}
                                      initialValues={initialValues}
                                      isNewEvent={isNewEvent}
                                      open={!!showModal}
                                      onCloseModal={this.closeModal}
                                      onSetErrorMessage={this.setErrorMessage}
                                      isAgente={me.ruolo === 'AGENTE'}
                                      isMyCalendar={!!this.state.isMyCalendar}
                                    />
                                  </div>
                                )
                              }}
                            </Query>
                          )
                        }}
                      </Query>
                    )
                  }}
                </Query>
              </div>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default CalendarioGiorno


// WEBPACK FOOTER //
// ./src/views/App/CalendarioGiorno/CalendarioGiorno.jsx